import { formatMoney } from '@betterment/core';
import { Box, Separator, Text } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { IdempotencyProviderWithFeatureRegistry } from '../../../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { CancelButton } from '../common/CancelButton';
import { StatusSection } from '../common/StatusSection';

export const Deposit: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemDeposit'>;
}> = ({ item }) => {
  return (
    <ActivityDrawerLayout title="Deposit">
      <DrawerListRow label="From" value={item.depositSourceAccount?.name ?? ''} />
      <Separator />
      <DrawerListRow label="To" value={item.depositDestinationAccount.name} />
      <Separator />
      <DrawerListRow label="Amount" value={item.amount ? formatMoney(item.amount) : ''} />
      <Separator />
      <DrawerListRow label="Note" value={item.transactionMemo?.reason ?? '—'} />
      {item.transactionMemo?.comment && (
        <Box css={{ paddingY: 'space.200' }}>
          <Text variant="text50" color="text.weak">
            {item.transactionMemo.comment}
          </Text>
        </Box>
      )}
      <Separator />
      <StatusSection statuses={item.statuses} />
      {item.isCancelable && (
        <>
          <Separator />
          <IdempotencyProviderWithFeatureRegistry featureName="cancelTransactionRequest">
            <CancelButton
              transactionType="deposit"
              transactionId={item.depositRequestId!}
              to={item.depositDestinationAccount.name}
              amount={item.amount ? formatMoney(item.amount) : ''}
            />
          </IdempotencyProviderWithFeatureRegistry>
        </>
      )}
    </ActivityDrawerLayout>
  );
};
